<template>
	<div class="banners__description-block-content">
		<p v-if="block.title" class="banners__description-block-item-title">
			{{ $rt(block.title) }}
		</p>
		<ul class="banners__description-list">
			<li v-for="(item, idx) in block.list" :key="idx">
				{{ $rt(item) }}
			</li>
		</ul>
		<small v-if="block.small" class="banners__description-block-item-small">
			{{ $rt(block.small) }}
		</small>
	</div>
</template>

<script setup lang="ts">
	const props = defineProps<{
		block: {
			title?: string
			list?: string[]
			small?: string
		}
	}>()

	const block = computed(() => ({
		title: props.block.title,
		list: props.block.list ?? [],
		small: props.block.small,
	}))
</script>

<style lang="scss" scoped>
	.banners__description-block-content {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
	.banners__description-list {
		padding-left: 1.5em;
		text-indent: -1.5em;
		list-style-type: disc;
	}
</style>
